import RangeSlider from './RangeSlider'
import React from 'react'
import type { FiltersProps } from '../../shared/Module'
import type { SyntheticEvent } from 'react'

interface FacetComponentProps {
  activeFilters: FiltersProps
  expanded: boolean
  filters: FiltersProps
  id: string
  modal: boolean
  onClick: Function
  onFilterDelete: Function
  onFilterSelect: Function
  prefix?: string
  title: string
}
const Facet = ({
  activeFilters = [],
  expanded,
  filters,
  id,
  onClick,
  onFilterDelete,
  onFilterSelect,
  prefix = '',
  title,
  modal,
}: FacetComponentProps) => {
  return (
    <fieldset className='c-filter__category accordion'>
      <legend>
        <button
          className='c-disclosure c-disclosure--filter'
          type='button'
          aria-expanded={expanded}
          aria-controls={`disclosure-filter-${prefix}-${id}`}
          onClick={(e) => toggleFacet(e, id)}
        >
          {title}
          {!expanded && activeFilters.length > 0 && (
            <span className='c-filter__selection'>{activeFilters.length}</span>
          )}
        </button>
      </legend>
      <div
        id={`disclosure-filter-${prefix}-${id}`}
        className='c-filter__list'
        hidden={!expanded}
      >
        {id === 'prices' ? (
          <RangeSlider
            min={Number(filters[0].value)}
            max={Number(filters[1].value)}
            id={id}
            onChange={handlePriceChange}
            value={
              activeFilters[0]?.value
                ? [
                    Number(activeFilters[0]?.value),
                    Number(activeFilters[1]?.value),
                  ]
                : [Number(filters[0].value), Number(filters[1].value)]
            }
            modal={modal}
          />
        ) : (
          <React.Fragment>
            {/* <span className='c-filter__detail'>
              {activeFilters.length > 1
                ? `${activeFilters.length} items sélectionnés`
                : `${activeFilters.length || 0} item sélectionné`}
            </span> */}
            {filters.map(({ label, value }) => (
              <div key={`${id}-${value}`} className='c-filter--block'>
                <input
                  checked={isFilterActive(value)}
                  id={`${prefix}-${id}-${value}`}
                  onChange={() => handleFilter({ label, value })}
                  type='checkbox'
                />
                <label
                  className='c-label c-label--checkbox c-label--highlight'
                  htmlFor={`${prefix}-${id}-${value}`}
                >
                  {label}
                </label>
              </div>
            ))}
          </React.Fragment>
        )}
      </div>
    </fieldset>
  )

  // Manage filter selection or removal
  function handleFilter(filter: any) {
    if (isFilterActive(filter.value)) {
      onFilterDelete({ ...filter, id })
    } else {
      onFilterSelect({ ...filter, id })
    }
  }

  // Delete previous selected value
  // Select new value
  function handlePriceChange({
    label,
    value,
  }: {
    label: string
    value: string
  }) {
    onFilterSelect({ id: 'prices', label, value })
  }

  // Check if the given filter is active
  function isFilterActive(filterValue: string | number | number[]) {
    return activeFilters.some(({ value }) => value === filterValue)
  }

  function toggleFacet(event: SyntheticEvent, id: string) {
    event.preventDefault()
    onClick(id)
  }
}

export default Facet
